/** @format */

import { P, type PermissionKey } from './permission-keys';

/**
 * The canonical project-detail section list. Single source of truth shared by
 * the projects app (detail-page content switch + RBAC gating) and the shell
 * sidebar (per-project tab links). Data-only — icons are mapped to lucide in
 * each consumer so this stays UI-framework agnostic.
 */
export type ProjectTab =
  | 'overview'
  | 'modules'
  | 'features'
  | 'tasks'
  | 'meetings'
  | 'team'
  | 'settings';

export interface ProjectTabConfig {
  id: ProjectTab;
  label: string;
  /** VIEW permission gating this tab. Omitted ⇒ always visible (e.g. tasks). */
  permission?: PermissionKey;
}

export const PROJECT_TABS: ProjectTabConfig[] = [
  { id: 'overview', label: 'Overview', permission: P.PROJECTS_VIEW_OVERVIEW },
  { id: 'modules', label: 'Modules', permission: P.HIERARCHY_MODULE_VIEW },
  { id: 'features', label: 'Features', permission: P.HIERARCHY_FEATURE_VIEW },
  { id: 'tasks', label: 'Tasks' },
  { id: 'meetings', label: 'Meetings', permission: P.MEETINGS_VIEW },
  { id: 'team', label: 'Team', permission: P.PROJECTS_VIEW_TEAM },
  { id: 'settings', label: 'Settings', permission: P.SETTINGS_PROJECT_VIEW },
];
